var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", [
        _c(
          "div",
          [
            _c("h2", { staticClass: "mb-0" }, [_vm._v("Fees")]),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-4" }, [
              _vm._v("The default fees for calculating the landed price.")
            ]),
            _vm._v(" "),
            _vm.form_data
              ? _c("Fees", {
                  model: {
                    value: _vm.form_data,
                    callback: function($$v) {
                      _vm.form_data = $$v
                    },
                    expression: "form_data"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("b-button", { on: { click: _vm.onSubmit } }, [_vm._v("Submit")])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7412b907", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7412b907","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/FeesPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7412b907","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/FeesPage.vue
// module chunks = 0